<div mat-dialog-content>
  <mat-grid-list cols="1" fxLayout="row" fxLayoutAlign="center center">
      <span mat-dialog-title><small>Cadastro de Empresa</small></span>
  </mat-grid-list>
</div>

<mat-vertical-stepper [linear]="false" #stepper class="call-operator">
  <mat-step [stepControl]="firstFormGroup">
    <form [formGroup]="formAddBusiness">
      <ng-template matStepLabel>Identificação:</ng-template>
      <p><small><b>Digite os dados da empresa:</b></small></p>
        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="cnpj" class="control-label">CNPJ</mat-label>
          <input matInput type="text" class="form-control" formControlName="cnpj"
          id="cnpj" placeholder="CNPJ" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="name" class="control-label">Razão Social</mat-label>
          <input matInput type="text" class="form-control" formControlName="name"
          id="name" placeholder="Razão Social" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="fantasy_name" class="control-label">Nome Fantasia</mat-label>
          <input matInput type="text" class="form-control" formControlName="fantasy_name"
          id="fantasy_name" placeholder="Nome Fantasia" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="ie" class="control-label">Inscrição Estadual</mat-label>
          <input matInput type="text" class="form-control" formControlName="ie"
          id="ie" placeholder="Inscrição Estadual" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="im" class="control-label">Inscrição Municipal</mat-label>
          <input matInput type="text" class="form-control" formControlName="im"
          id="im" placeholder="Inscrição Municipal" required>
        </mat-form-field>

      <div>
        <button mat-stroked-button color="primary" class="margin-form" matStepperNext>Próximo</button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="secondFormGroup" >
    <form [formGroup]="formAddBusiness">
      <ng-template matStepLabel>Endereço:</ng-template>
      <p><small><b>Informe o endereço:</b></small></p>
        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="cep" class="control-label">CEP</mat-label>
          <input matInput type="text" class="form-control"
          id="cep" formControlName="cep" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="city_code" class="control-label">Cidade</mat-label>
          <input matInput type="text" class="form-control"
          id="city_code" formControlName="city_code" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="uf_code" class="control-label">Estado</mat-label>
          <input matInput type="text" class="form-control"
          id="uf_code" formControlName="uf_code" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="address" class="control-label">Endereço</mat-label>
          <input matInput type="text" class="form-control"
          formControlName="address" id="address" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="number" class="control-label">Nº</mat-label>
          <input matInput type="text" class="form-control"
          id="number" formControlName="number">
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="district" class="control-label">Bairro</mat-label>
          <input matInput type="text" class="form-control"
          id="district" formControlName="district" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="adress_complement" class="control-label">Complemento</mat-label>
          <input matInput type="text" class="form-control"
          id="adress_complement" formControlName="adress_complement">
        </mat-form-field>

        <mat-form-field appearance="outline" class="padding-form">
          <mat-label for="reference_point" class="control-label">Ponto de Referência</mat-label>
          <input matInput type="text" class="form-control"
          id="reference_point" formControlName="reference_point">
        </mat-form-field>

      <div>
        <button mat-stroked-button color="primary" class="margin-form" matStepperPrevious>Voltar</button>
        <button mat-stroked-button color="primary" class="margin-form" matStepperNext>Próximo</button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="thirdFormGroup">
    <form [formGroup]="formAddBusiness">
      <ng-template matStepLabel>Contato:</ng-template>
      <p><small><b>Informe os contatos da empresa:</b></small></p>
      <mat-form-field appearance="outline"  class="padding-form">
        <mat-label for="phone" class="control-label">Telefone</mat-label>
        <input matInput type="phone" mask="(00)00000-0000" class="form-control" formControlName="phone"
        id="phone" placeholder="Telefone">
      </mat-form-field>

      <mat-form-field appearance="outline"  class="padding-form">
        <mat-label for="cellphone" class="control-label">Celular</mat-label>
        <input matInput mask="(00)00000-0000" type="cellphone" class="form-control" formControlName="cellphone"
        id="cellphone" placeholder="Celular" required>
      </mat-form-field>

      <mat-form-field appearance="outline"  class="padding-form">
        <mat-label for="email" class="control-label">Email</mat-label>
        <input matInput type="email" class="form-control" formControlName="email"
        id="email" placeholder="nome@email.com">
      </mat-form-field>

      <mat-form-field appearance="outline"  class="padding-form">
        <mat-label for="comercial_email" class="control-label">Email Comercial</mat-label>
        <input matInput type="comercial_email" class="form-control"
        formControlName="comercial_email" id="comercial_email" placeholder="nome@email.com">
      </mat-form-field>

      <div>
        <button mat-stroked-button color="primary" class="margin-form" matStepperPrevious>Voltar</button>
        <button mat-stroked-button color="primary" class="margin-form" matStepperNext>Próximo</button>
      </div>
    </form>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Confirmação:</ng-template>
    <p>Para alterar alguma informação clique em Voltar.</p>
    <div>
      <button mat-stroked-button color="primary" class="margin-form" matStepperPrevious>Voltar</button>
      <button mat-stroked-button color="accent" class="margin-form" type="submit" >Salvar</button>
      <button mat-stroked-button color="primary" class="margin-form" (click)="stepper.reset()">Novo</button>
    </div>
  </mat-step>
</mat-vertical-stepper>

